module.exports = __webpack_public_path__ + "static/media/MDC_Vert_Black.e5829cf6.png";